module.exports = __webpack_public_path__ + "static/img/caochang.df933be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/caochang.jpg
// module id = Q4Ua
// module chunks = 18